














































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Sticky from 'vue-sticky-directive';

@Component({
    name: 'SignUpDialog',
    components: {
        SignUp: () => import('./SignUp.vue'),
    },
    directives: {
        Sticky,
    },
})
export default class SignUpDialog extends Vue {

    @Prop({type: Boolean, default: false})
    autofill!: boolean;

    @Prop({type: Boolean, default: null})
    open!: boolean | null;

    @Watch('open', {immediate: true}) 
    onOpenChanged(newVal: boolean, oldVal: boolean) {
        this.dialog = (this.open === true);
    }

    @Watch('dialog') 
    onDialogChanged(newVal: boolean, oldVal: boolean) {
        this.$emit('clicked', newVal);
    }

    private dialog = false;
    private fabClass = '--fab-on';

}
